module.exports = __webpack_public_path__ + "media/admin/cs_evaluation_request_004_sm-e286ed41.png";